import React from 'react';
import { InputNumber, Select, Space } from 'antd';
import { EASING_TYPES } from 'util/constants';
import styles from '../../../event-timeline.module.css';

const { Option } = Select;

interface ScaleParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const ScaleParams: React.FC<ScaleParamsProps> = ({ params, setParams }) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span>Scale X:</span>
        <InputNumber
          value={params.scale?.x || 1}
          onChange={(value) =>
            setParams({
              ...params,
              scale: {
                ...params.scale,
                x: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span>Scale Y:</span>
        <InputNumber
          value={params.scale?.y || 1}
          onChange={(value) =>
            setParams({
              ...params,
              scale: {
                ...params.scale,
                y: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span>Scale Z:</span>
        <InputNumber
          value={params.scale?.z || 1}
          onChange={(value) =>
            setParams({
              ...params,
              scale: {
                ...params.scale,
                z: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span>Easing:</span>
        <Select
          value={params.easing || 'linear'}
          onChange={(value) => setParams({ ...params, easing: value })}
          style={{ width: '100%' }}
        >
          <Option value={EASING_TYPES.LINEAR}>Linear</Option>
          <Option value={EASING_TYPES.EASE_IN}>Ease In</Option>
          <Option value={EASING_TYPES.EASE_OUT}>Ease Out</Option>
          <Option value={EASING_TYPES.EASE_IN_OUT}>Ease In Out</Option>
        </Select>
      </Space>
    </div>
  );
};

export default ScaleParams;
